var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Manage-system-main",class:{ 'Manage-system-main-mobile': _vm.isMobile }},[_c('div',{staticClass:"center"},[_c('Base-title',{attrs:{"title":"科学管理 双向驱动"}}),_c('Manage-system-content')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }